import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import firebase from 'firebase/compat/app';

function AuthHandler({ setUser, setLoading }) {
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
        user.getIdTokenResult()
          .then((tokenResult) => {
            setUser(tokenResult); // Save custom claims too
          })
          .catch(console.error);
        setLoading(false);
      } else {
        setLoading(false);
        navigate('/'); // 👈 Navigate instead of window.open
      }
    });

    return () => unsubscribe();
  }, [navigate, setUser, setLoading]);

  return null;
}

export default AuthHandler;
